import React from 'react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-labelledby="prueba-titulo" className="w-full border-t border-line bg-panel py-20 sm:py-28" data-id="element-109" data-mp="3kpuirmacsxk5">
      <div className="mx-auto max-w-6xl px-4" data-id="element-110" data-mp="3fyw1ajdmptfb">
        <h2 id="prueba-titulo" className="font-display text-3xl font-bold uppercase tracking-tight text-bone sm:text-4xl" data-id="element-111" data-mp="3fxkxijk6olo7">
          Corredores que ya cambiaron el enfoque
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-112" data-mp="31zwap66k34gi">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-lg border border-line bg-panel2 p-7" data-id="element-113" data-mp="2x0tfedgdoclq">
              <div className="font-display text-4xl font-extrabold leading-none text-lime" data-id="element-114" data-mp="2s30adnqt9on1">{t.metric}</div>
              <p className="mt-2 text-xs uppercase tracking-[0.15em] text-mute" data-id="element-115" data-mp="v8555k5bgowg">{t.metricLabel}</p>

              <blockquote className="mt-6 text-lg leading-relaxed text-bone/90" data-id="element-116" data-mp="qbn3it5a96oc">«{t.quote}»</blockquote>

              <figcaption className="mt-auto flex items-center gap-3 pt-7" data-id="element-117" data-mp="h4de4p2e1u5r">
                <img src={t.avatar} alt={`Retrato de ${t.name}`} className="h-11 w-11 rounded-full object-cover" data-id="element-118" data-mp="m62oe2hse3ss" />
                <div data-id="element-119" data-mp="c6bwm8km22we">
                  <p className="font-semibold text-bone" data-id="element-120" data-mp="c7mwvyeuksir">{t.name}</p>
                  <p className="text-sm text-mute" data-id="element-121" data-mp="zvwf6qcuqy55">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}